import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { ContactQuery } from "../types";

export const CONTACT_QUERY = gql`
  query GetContactDetails($contactId: Long) {
    contact(id: $contactId) {
      id
      contactId
      name
      primaryAddress {
        id
        address1
        address2
        zipCode
        city
        phone1
        email
      }
      portfolios {
        id
        shortName
        name
        status
        modelPortfolio {
          id
          name
          linkedPortfolio {
            id
            name
          }
        }
      }
    }
  }
`;

export const useGetContactDetails = (
  contactId: number | string | undefined
) => {
  const { loading, error, data, refetch } = useQuery<ContactQuery>(
    CONTACT_QUERY,
    {
      variables: { contactId },
      skip: !contactId,
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    }
  );

  return {
    loading: loading,
    error: error,
    data: data?.contact,
    refetch,
  };
};
